import { render, staticRenderFns } from "./addpzList.vue?vue&type=template&id=70753b1e&scoped=true&"
import script from "./addpzList.vue?vue&type=script&lang=js&"
export * from "./addpzList.vue?vue&type=script&lang=js&"
import style0 from "./addpzList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./addpzList.vue?vue&type=style&index=1&id=70753b1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70753b1e",
  null
  
)

export default component.exports